export enum ConfigType {
  OFF = 'off',
  ALL = 'all',
  ACCUMULATE = 'accumulate',
  INFO = 'info',
  WARNING = 'warning',
  CUSTOM = 'custom'
}


export class ConfigTypeUtil {
  static values() {
    return Object.values(ConfigType);
  }
  
  static fromString(configType: string) {
    switch (configType) {
      case ConfigType.OFF: return ConfigType.OFF;
      case ConfigType.ALL: return ConfigType.ALL;
      case ConfigType.ACCUMULATE: return ConfigType.ACCUMULATE;
      case ConfigType.INFO: return ConfigType.INFO;
      case ConfigType.WARNING: return ConfigType.WARNING;
      case ConfigType.CUSTOM: return ConfigType.CUSTOM;
      default: return ConfigType.ALL;
    }
  }
}